var _path, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTripleArrow = function SvgTripleArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 17,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.222.5H.043l7.002 8-7.002 8h4.18l7.001-8-7.002-8Z",
    fill: "url(#triple-arrow_svg__a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.593.5H8.414l7.002 8-7.002 8h4.18l7.001-8-7.002-8Z",
    fill: "url(#triple-arrow_svg__b)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m16.777.5 7.002 8-7.002 8h4.18l7.002-8-7.003-8h-4.179Z",
    fill: "url(#triple-arrow_svg__c)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "triple-arrow_svg__a",
    x1: 1.471,
    y1: 0.224,
    x2: 11.583,
    y2: 0.355,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16191F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6C727E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "triple-arrow_svg__b",
    x1: 9.842,
    y1: 0.224,
    x2: 19.954,
    y2: 0.355,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16191F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6C727E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "triple-arrow_svg__c",
    x1: 18.205,
    y1: 0.224,
    x2: 28.318,
    y2: 0.355,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16191F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6C727E"
  })))));
};
export default SvgTripleArrow;